export default __webpack_public_path__ + "static/media/R1koritu.ae18c8c0.mp3";